/** 국내 연락처: 공백·하이픈을 정리한 0으로 시작하는 9~11자리 숫자. 서버와 동일한 규칙. */
export const normalizeDemandContact = (value: string) => value.trim().replace(/[ -]/g, "")
export const isValidDemandContact = (value: string) => /^0[0-9]{8,10}$/.test(normalizeDemandContact(value))
